import { useState } from "react";
import { Play } from "lucide-react";
import { YOUTUBE_ID, HERO_POSTER, LOGO_MARK } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="aftermovie" className="relative py-20 sm:py-28 bg-brand-deep/40 overflow-hidden" data-testid="video-section">
      <div className="absolute inset-0 bg-[radial-gradient(900px_480px_at_50%_45%,rgba(0,142,255,0.10),transparent_65%)] pointer-events-none" />

      {/* Marca d'água · ícone do evento */}
      <img
        src={LOGO_MARK}
        alt=""
        aria-hidden="true"
        className="absolute -right-20 top-1/2 -translate-y-1/2 h-[440px] w-auto opacity-[0.05] pointer-events-none select-none rotate-[8deg]"
      />
      <img
        src={LOGO_MARK}
        alt=""
        aria-hidden="true"
        className="absolute -left-24 -top-16 h-[300px] w-auto opacity-[0.035] pointer-events-none select-none -rotate-[12deg]"
      />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="heading-lg" data-testid="video-heading">
            <MaskLine inView>Reviva a última edição</MaskLine>
            <MaskLine inView delay={0.12}>
              <span className="text-gradient-blue">e sinta a energia.</span>
            </MaskLine>
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-4 text-white/60 text-sm sm:text-base">
              Pregoeiros Summit · a maior experiência em licitações e contratos do Brasil
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div
            className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_40px_120px_rgba(0,20,60,0.55)] bg-brand-elev aspect-video"
            data-testid="video-frame"
          >
            {!playing ? (
              <button
                onClick={() => setPlaying(true)}
                className="group absolute inset-0 w-full h-full"
                aria-label="Assistir ao aftermovie"
                data-testid="video-play-button"
              >
                <img
                  src={HERO_POSTER}
                  alt="Auditório lotado na última edição do Pregoeiros Summit"
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
                <span className="absolute inset-0 bg-brand-base/45 group-hover:bg-brand-base/30 transition-colors duration-500" />

                {/* Botão play */}
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="relative flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full bg-white/[0.10] backdrop-blur-xl border border-white/25 shadow-[inset_0_1px_0_rgba(255,255,255,0.20),0_20px_50px_rgba(3,10,26,0.55)] transition-all duration-300 group-hover:scale-110 group-hover:bg-white/[0.16]">
                    <span className="absolute inset-0 rounded-full bg-brand-blue/40 animate-ping" />
                    <Play size={30} className="relative text-brand-deep fill-brand-deep ml-1" />
                  </span>
                </span>
              </button>
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0&playsinline=1`}
                className="absolute inset-0 w-full h-full"
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
                title="Aftermovie Pregoeiros Summit"
                frameBorder="0"
                data-testid="video-player"
              />
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
